import type { SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: 'Framerank',
    description: 'Every AI video and image tool, ranked. Editorial scores, real free tiers, open-source picks, head-to-head matchups and a tracker for tools that shut down.',
    url: getOrigin()
}

export const mainNav = [
    { href: '/tools', label: 'Directory' },
    { href: '/compare', label: 'Matchups' },
    { href: '/use-cases', label: 'Use cases' },
    { href: '/free-tools', label: 'Free tools' },
    { href: '/shut-down', label: 'Shut down' }
]
